import type {
  TagPresetType,
} from '@n3/css-base';

export const tagPresets: Record<string, TagPresetType> = {
  BLUE: 'blue',
  BLUE_CONTRAST: 'blue_contrast',
  CYAN: 'cyan',
  CYAN_CONTRAST: 'cyan_contrast',
  LIGHT_GRAY: 'light_gray',
  GRAY: 'gray',
  GREEN: 'green',
  GREEN_CONTRAST: 'green_contrast',
  MAGENTA: 'magenta',
  MAGENTA_CONTRAST: 'magenta_contrast',
  YELLOW: 'yellow',
  YELLOW_CONTRAST: 'yellow_contrast',
  PURPLE: 'purple',
  PURPLE_CONTRAST: 'purple_contrast',
  RED: 'red',
  RED_CONTRAST: 'red_contrast',
  TEAL: 'teal',
  TEAL_CONTRAST: 'teal_contrast',
  ORANGE: 'orange',
  ORANGE_CONTRAST: 'orange_contrast',
  OUTLINE: 'outline',
};
